import getHash from '../internal/get-hash';
import setEntry from 'lodash.set';
import unsetEntry from 'lodash.unset';
import getByPath from 'lodash.get';
import cloneDeep from 'lodash.clonedeep';
import { DROP_VIEWMODEL_STATE, VIEWMODEL_STATE_UPDATE } from '../internal/action-types';
import { ResultStatus } from '../types';
export var namedSelectors = 'namedSelectors';
export var builtInSelectors = 'builtInSelectors';

var getSelector = function getSelector(action) {
  return action.selectorId || action;
};

export var getEntryPath = function getEntryPath(selector) {
  if (typeof selector === 'string') {
    return namedSelectors + "." + getHash(selector);
  }

  var _selector$query = selector.query,
      name = _selector$query.name,
      aggregateIds = _selector$query.aggregateIds,
      args = _selector$query.args;
  return builtInSelectors + "." + getHash(name) + "." + getHash(aggregateIds) + "." + getHash(args, 'no-args');
};
export var getEntry = function getEntry(state, selector, placeholder) {
  return getByPath(state, getEntryPath(selector), placeholder);
};
var initialState = {};
export var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case VIEWMODEL_STATE_UPDATE:
      return setEntry(cloneDeep(state), getEntryPath(getSelector(action)), {
        status: action.initial ? ResultStatus.Requested : ResultStatus.Ready,
        data: action.state
      });

    case DROP_VIEWMODEL_STATE:
      var newState = cloneDeep(state);
      unsetEntry(newState, getEntryPath(getSelector(action)));
      return newState;

    default:
      return state;
  }
};
//# sourceMappingURL=view-model-reducer.js.map